import { fetch } from "../Helper/httpRequest";

const API_HOST = process.env.REACT_APP_API_HOST + "/users/v1";

export const getProductList = (data) => {
  return fetch("get", `${API_HOST}/user/marketplace/list`, {}, {}, data);
};

const addToCart = (data) => {
  return fetch("post", `${API_HOST}/user/cart/add-product`, data, {}, {});
};

const updateCart = (data) => {
  return fetch("post", `${API_HOST}/user/cart/edit-product`, data, {}, {});
};

const getCartItems = () => {
  return fetch("get", `${API_HOST}/user/cart/list`, {}, {}, {});
};

const deleteItemFromCart = (data) => {
  return fetch("post", `${API_HOST}/user/cart/delete-item`, data, {}, {});
};

const emptyCart = (data) => {
  return fetch("post", `${API_HOST}/user/cart/empty`, data, {}, {});
};

const marketPlaceCheckout = (data) => {
  return fetch("post", `${API_HOST}/user/cart/checkout`, data, {}, {});
};

const getClientSecret = (data) => {
  return fetch("post", `${API_HOST}/user/create_intent`, data, {}, {});
};

const stripeWebhook = (data) => {
  return fetch("post", `${API_HOST}/user/webhook`, data, {}, {});
};

export const marketPlace = {
  getProductList,
  addToCart,
  updateCart,
  getCartItems,
  deleteItemFromCart,
  emptyCart,
  marketPlaceCheckout,
  getClientSecret,
  stripeWebhook,
};
